import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../atoms/Button';
import ThreeDotsButton from '../../../atoms/ThreeDotsButton';

const Actions = ({ primaryAction, secondaryAction, onMore }) => {
  const hasPrimary = false; // moved to dropdown
  const hasSecondary = Boolean(secondaryAction?.label);

  if (!hasPrimary && !hasSecondary && !onMore) {
    return null;
  }

  return (
    <div className="channel-header__actions">
      {hasSecondary && (
        <Button
          variant="secondary"
          className="channel-header__action"
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled}
        >
          {secondaryAction.label}
        </Button>
      )}
      {/* primary action hidden; now available via 3-dots dropdown */}
      <ThreeDotsButton className="channel-header__more" onClick={onMore} size={28} />
    </div>
  );
};

Actions.propTypes = {
  primaryAction: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }),
  secondaryAction: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }),
  onMore: PropTypes.func,
};

Actions.defaultProps = {
  primaryAction: undefined,
  secondaryAction: undefined,
  onMore: undefined,
};

export default Actions;


